import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { IosInstallGuideDialogComponent } from '../ios-install-guide-dialog/ios-install-guide-dialog';
import { PwaInstallService } from '../../services/pwa-install.service';

@Component({
  selector: 'app-pwa-install-prompt',
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslocoPipe],
  templateUrl: './pwa-install-prompt.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PwaInstallPromptComponent {
  private readonly dialog = inject(MatDialog);
  readonly pwaInstall = inject(PwaInstallService);

  async onInstallClick(): Promise<void> {
    if (this.pwaInstall.isIos) {
      this.dialog.open(IosInstallGuideDialogComponent, {
        width: '30rem',
        maxWidth: 'calc(100vw - 2rem)',
      });
      return;
    }

    await this.pwaInstall.promptInstall();
  }

  dismiss(): void {
    this.pwaInstall.dismissSuggestion();
  }
}
